import { tns } from '../../tiny-slider/src/tiny-slider';

class CardCarousel {
  constructor() {
    this.carousels = Array.from(document.querySelectorAll('.js-card-carousel__list'));
    this.init();
  }

  init() {
    this.carousels.forEach(carousel => {
      tns({
        animateDelay: false,
        autoplay: true,
        autoplayButtonOutput: false,
        autoplayHoverPause: true,
        autoplayTimeout: 0,
        container: carousel,
        controls: false,
        items: 6,
        mouseDrag: true,
        nav: false,
        preventActionWhenRunning: true,
        speed: carousel.dataset.speed ? carousel.dataset.speed : 3000,
        slideBy: 1,
      });
    });
  }
}

export default CardCarousel;
